import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
};

export const userSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    addData: (state) => {
      state.data = [
        {
          SNo: 1,
          userId: 'U0001',
          name: 'Ashok Kumar',
          email: 'ashok@growero.com',
          phone: '9393993323',
          Status: true,
        },
        {
          SNo: 2,
          userId: 'U0002',
          name: 'Pankaj Singh',
          email: 'pankaj@growero.com',
          phone: '9442134422',
          Status: false,
        },
      ];
    },
  },
});

// Action creators are generated for each case reducer function
export const { addData } = userSlice.actions;

export default userSlice.reducer;
